import axios from "../utils/axios";

// Encoding settings of the quality presets (resolution is the frame height, as an integer). "source" sends nulls (the file is imported as is).
const QUALITY_PRESETS = {
    source: { pixel_format: null, resolution: null, crf: null },
    low: { pixel_format: null, resolution: null, crf: 26 },
    medium: { pixel_format: null, resolution: null, crf: 23 },
    high: { pixel_format: null, resolution: null, crf: 18 }
};

// Id of a communication with the plugin: SHA-256 (hex) of the timestamp in milliseconds. Falls back to
// a 32 bit FNV-1a hash where crypto.subtle isn't available (it needs a secure context: https / localhost)
async function buildRequestId() {
    const timestamp = String(Date.now());
    if (globalThis.crypto?.subtle) {
        const digest = await globalThis.crypto.subtle.digest("SHA-256", new TextEncoder().encode(timestamp));
        return Array.from(new Uint8Array(digest)).map(byte => byte.toString(16).padStart(2, "0")).join("");
    }
    let hash = 0x811c9dc5;
    for (let i = 0; i < timestamp.length; i += 1) {
        hash ^= timestamp.charCodeAt(i);
        hash = Math.imul(hash, 0x01000193) >>> 0;
    }
    return hash.toString(16).padStart(8, "0");
}

// quality: "source" | "low" | "medium" | "high" | "custom". The backend doesn't receive the
// quality name: it gets pixel_format, resolution and crf, taken from the preset or, for
// "custom", from the values the user picked.
// Fails with status 409 when no plugin of the user is connected.
export async function importClipsToPlugin(clips, route, pluginKey, { quality, resolution, pixelFormat, crf }){
    const encoding = quality === "custom"
        ? { pixel_format: pixelFormat, resolution, crf }
        : QUALITY_PRESETS[quality];
    if (!encoding) throw new Error(`Unknown import quality: ${quality}`);

    const idList = clips.map(clip => clip.id);
    const newClips = {
        "request_id": await buildRequestId(),
        "key_moment_ids" : route !== "clips" ? idList : [],
        "logic_clip_ids" : route === "clips" ? idList : [],
        "audio_type": "COMMENTARY",
        "plugin_key": pluginKey,
        "margin_chunks": 1,
        ...encoding
    };
    const response = await axios.post(`plugin/import`, newClips);
    return response.data;
}

// Checks that this page was opened by the plugin: pluginKey must be the plugin_key of
// the current (plugin) session and a plugin socket must be connected with that session.
// Fails with 403 on a wrong plugin_key (or an inactive session), 409 when the plugin isn't connected.
export async function validatePluginAccess(pluginKey){
    const response = await axios.post(`plugin_sse/validate`, { plugin_key: pluginKey });
    return response.data
}
